




























































import { Component, Mixins } from "vue-property-decorator";
import { Getter } from "vuex-class";
import mixins from "@/mixins";
import uuid from "uuid/v4";

@Component
class WithdrawAddress extends Mixins(mixins.page) {
  @Getter("wallet/mixin/getAssetById") getAssetById;

  initing = true;

  address: any = {};

  destination = "";

  label = "";

  tag = "";

  amount = "";

  get title() {
    return this.$t("common.withdraw") as string;
  }

  get bindAmount() {
    return this.amount;
  }

  set bindAmount(val) {
    const precision = this.amountPrecision;
    this.amount = this.$common.utils.number.toPrecision(
      val,
      precision
    ) as string;
    const amountInput: any = this.$refs.amountInput;
    amountInput.lazyValue = this.amount;
  }

  get id() {
    return this.$route.query.assetId as string;
  }

  get addressId() {
    return this.$route.query.addressId as string;
  }

  get asset() {
    return this.getAssetById(this.id);
  }

  get chainLogo() {
    return this.$common.utils.helper.getChainLogo(this, this.asset);
  }

  get addressLabel() {
    return this.$t("wallet.withdraw.label.address", { name: this.label });
  }

  get addressValue() {
    const destination = this.destination;
    return this.tag ? `${destination}:${this.tag}` : destination;
  }

  get assetSymbol() {
    return (this.asset && this.asset.symbol) || "";
  }

  get rules() {
    return {
      amount: [
        v => !!v || this.$t("common.amount.required"),
        v =>
          (!isNaN(Number(v)) && Number(v) > 0) ||
          this.$t("common.amount.invalid")
      ]
    };
  }

  // get amountHint() {
  //   return this.balance
  //     ? this.$t("wallet.withdraw.hint.amount", { balance: this.balance })
  //     : "";
  // }

  get balance() {
    return (this.asset && this.asset.balance) || "";
  }

  get amountPrecision() {
    if (!this.balance) {
      return 0;
    }
    return this.$common.utils.number.getPrecision(this.balance);
  }

  get fee() {
    return (this.address && this.address.fee) || "";
  }

  get feeAsset() {
    if (!this.asset) {
      return "";
    }
    const id = this.asset && this.asset.chain_id;
    return this.getAssetById(id);
  }

  get feeAssetSymbol() {
    return (this.feeAsset && this.feeAsset.symbol) || "";
  }

  mounted() {
    this.init();
  }

  async init() {
    this.initing = true;
    if (this.addressId) {
      await this.requestAddressInfo(this.addressId);
      const feeBalance = +(this.feeAsset && this.feeAsset.balance);
      const feeAsset = this.feeAsset;
      const symbol = feeAsset && feeAsset.symbol;
      const fee = +this.fee;
      if (feeBalance < fee) {
        this.$helper.message(
          this,
          {
            title: this.$t("wallet.withdraw.fee.inffrence") as string,
            description: this.$t("wallet.withdraw.fee.inffrence.description", {
              amount: fee + symbol,
              symbol: symbol
            }) as string,
            ok: this.$t("wallet.withdraw.to-buy") as string
          },
          {
            onOK: () =>
              this.$helper.toFusionPath(this, "trade", {
                name: "instant",
                query: { wanted: symbol }
              })
          }
        );
      }
    }
    this.initing = false;
  }

  handleFill() {
    this.bindAmount = this.balance;
  }

  handleSend() {
    const form = this.$refs.form as any;
    const valid = form.validate();
    if (valid) {
      this.withdraw();
    }
  }

  async requestAddressInfo(id) {
    try {
      const res = await this.$api.wallet.mixin.getAddress(id);
      this.destination = res.destination;
      this.label = res.label;
      this.tag = res.tag;
      this.address = res;
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
    }
  }

  withdraw() {
    const symbol = this.asset.symbol;
    if (+this.amount > +this.balance) {
      this.$helper.message(
        this,
        {
          title: this.$t("wallet.withdraw.inffrence") as string,
          description: this.$t("wallet.withdraw.inffrence.description", {
            symbol
          }) as string,
          ok: this.$t("wallet.withdraw.to-buy") as string
        },
        {
          onOK: () =>
            this.$helper.toFusionPath(this, "trade", {
              name: "instant",
              query: { wanted: symbol }
            })
        }
      );
      return;
    }
    const id = uuid();
    const withdrawUrl = `mixin://withdrawal?address=${this.addressId}&asset=${
      this.id
    }&amount=${this.amount}&memo=${encodeURIComponent(this.tag)}&trace=${id}`;
    window.location.href = withdrawUrl;
    this.$root.$emit(this.$rootEvents.PIN_ENTER, () => {
      this.toAddresses();
    });
  }

  toAddresses() {
    this.$helper.toFusionPath(this, "wallet", {
      name: "snapshots-id",
      params: { id: this.id }
    });
  }
}
export default WithdrawAddress;
